import { useEffect } from 'react';
import { beamerInitialize } from 'react-beamer';

import { UserType } from 'store/slices/authSlice';

// On initial user load run Beamer script and fetch available post respecting set segment filters
export const useBeamer = (user: UserType | null) => {
  useEffect(() => {
    if (!process.env.REACT_APP_BEAMER_PRODUCT_ID) return;
    if (!user) return;

    beamerInitialize(process.env.REACT_APP_BEAMER_PRODUCT_ID, false, {
      button: false,
      selector: '.beamerButton',
      top: -4,
      right: -4,
      user_id: String(user.user_id),
      user_email: user.email,
      user_name: user.name,
    });
  }, [user]);
};
